export default "__VITE_ASSET__C9tp9Tge__"